export class Storage {
    static STORAGE_KEY = '_totem-storage';
    static keys: string[] = [];

    constructor() {
        this.__createStorageConditionally();
        this.__populateKeys();
    }

    private __createStorageConditionally() {
        if (!this.getAll()) {
            this.unset();
        }
    }

    private __populateKeys() {
        Storage.keys = Object.keys(this.getAll());
    }

    get<T = unknown>(key: string): T | undefined {
        return this.getAll()[key] as T | undefined;
    }

    getAll(): Record<string, any> {
        const storageItem = window.localStorage.getItem(Storage.STORAGE_KEY);
        if (storageItem && storageItem !== '[object Object]') {
            try {
                return JSON.parse(storageItem) as Record<string, unknown>;
            } catch {
                return {};
            }
        }
        return {};
    }

    set<T = unknown>(key: string, value: T): Record<string, unknown> {
        const newItems = {
            ...this.getAll(),
            [key]: value,
        };
        this.setAll(newItems);
        return newItems;
    }

    setAll(meta: Record<string, unknown>): Record<string, unknown> {
        const newMeta = JSON.stringify(meta);
        window.localStorage.setItem(Storage.STORAGE_KEY, newMeta);
        this.__populateKeys();
        return meta;
    }

    remove<T = unknown>(key: string): T | undefined {
        const { [key]: discardedItem, ...rest } = this.getAll();
        this.setAll(rest);
        this.__populateKeys();
        return discardedItem as T | undefined;
    }

    unset(): Record<string, any> {
        window.localStorage.setItem(Storage.STORAGE_KEY, '{}');
        return {};
    }

    discard(): void {
        return window.localStorage.removeItem(Storage.STORAGE_KEY);
    }
}
